// import $ from "jquery";

import baseClass from "./base";
import seoToolsClass from "./seoTools";

baseClass.CommandExecuterAdd("jscProcessMeta", function (obj) {
  try {
    if (obj.obj == undefined) return;
    var metaObj = obj.obj;

    seoToolsClass.setTitle(metaObj.title);
    seoToolsClass.setCharset(metaObj.charset);
    seoToolsClass.setAuthor(metaObj.author);
    seoToolsClass.setDescription(metaObj.description);
    seoToolsClass.setKeyWords(metaObj.keyWords);
    seoToolsClass.setDcLanguage(metaObj.dcLanguage);
    seoToolsClass.setResourseType(metaObj.resourseType);
    seoToolsClass.setRevisitAfter(metaObj.revisitAfter);
    seoToolsClass.setRating(metaObj.rating);
    seoToolsClass.setUrlCanonical(metaObj.urlCanonical);
    seoToolsClass.setDcFormat(metaObj.dcFormat);
    seoToolsClass.setImage(metaObj.image);
    seoToolsClass.setAlternateUrls(metaObj.alternateUrls);
  } catch (e) {
    console.log("err: jscProcessMeta", e);
  }
});

baseClass.CommandExecuterAdd("jscSetJwt", function (obj) {
  try {
    let jwt = obj.jwt;
    if (jwt != undefined) $("meta[name='jwt']").attr("content", jwt);
  } catch (e) {
    console.log("err: jscShow", e);
  }
});

baseClass.CommandExecuterAdd("jscShow", function (obj) {
  try {
    let selector = obj.selector;
    $(selector).show();
  } catch (e) {
    console.log("err: jscShow", e);
  }
});

baseClass.CommandExecuterAdd("jscHide", function (obj) {
  try {
    let selector = obj.selector;
    $(selector).hide();
  } catch (e) {
    console.log("err: jscHide", e);
  }
});

baseClass.CommandExecuterAdd("jscAppend", function (obj) {
  try {
    let selector = obj.selector;
    console.log("jscAppend", selector);
    let html = obj.html;
    $(selector).append(html);
  } catch (e) {
    console.log("err: jscAppend", e);
  }
});

baseClass.CommandExecuterAdd("jscChangeHTML", function (obj) {
  try {
    let selector = obj.selector;
    let html = obj.html;

    if (html != undefined) {
      $(selector).html(html);
    } else {
      $(selector).html("");
    }
  } catch (e) {
    console.log("err: jscChangeHTML", e);
  }
});

baseClass.CommandExecuterAdd("jscChangeAttr", function (obj) {
  try {
    let selector = obj.selector;
    console.log("jscChangeAttr", selector);
    let attr = obj.attr;
    let value = obj.value;

    if (attr != undefined) {
      $(selector).attr(attr, value);
    } 
  } catch (e) {
    console.log("err: jscChangeAtt", e);
  }
});

baseClass.CommandExecuterAdd("jscAddClass", function (obj) {
  try {
    let selector = obj.selector;
    let _class = obj.class;
    $(selector).addClass(_class);
  } catch (e) {
    console.log("err: jscAddClass", e);
  }
});

baseClass.CommandExecuterAdd("jscRemClass", function (obj) {
  try {
    let selector = obj.selector;
    let _class = obj.class;
    $(selector).removeClass(_class);
  } catch (e) {
    console.log("err: jscRemClass", e);
  }
});

baseClass.CommandExecuterAdd("jscReset", function (obj) {
  try {
    let selector = obj.selector;
    $(selector).each(function () {
      if (this.tagName === "FORM") {
        this.reset(); 
      }
    });
  } catch (e) {
    console.log("err: jscReset", e);
  }
});

baseClass.CommandExecuterAdd("jscRemove", function (obj) {
  try {
    let selector = obj.selector;
    $(selector).remove();
  } catch (e) {
    console.log("err: jscRemove", e);
  }
});

baseClass.CommandExecuterAdd("jscChangeBrowserLocation", function (obj) {
  try {
    let href = obj.href;
    history.pushState({}, null, href);
  } catch (e) {
    console.log("err: jscChangeBrowserLocation", e);
  }
});

baseClass.CommandExecuterAdd("jscRedirect", function (obj) {
  try {
    let href = obj.href;

    if (href != undefined) {

      var type = obj.type != undefined ? obj.type : "simple";
      var targetid = obj.targetid != undefined ? obj.targetid : "main";

      if (type == "simple") {
        window.location.href = href;
      }

      var tobj = {};
      tobj.href = href;
      tobj.targetid = targetid;

      baseClass.loadDataAjax(obj, tobj);
    }
  } catch (e) {
    console.log("err: jscRedirect", e);
  }
});

function commandUnSelecMeny(uniqueid, classname) {
  // $(this).removeClass(classname);

  if (uniqueid == undefined) return;
  if (!uniqueid) return;

  $(".js_menu").each(function () {
    if ($(this).attr("data-uniqueid") == uniqueid) return;

    $(this).removeClass(classname);
  });
}

function commandSelecMeny(uniqueid, classname) {
  if (uniqueid == undefined) return;
  if (!uniqueid) return;

  $(".js_menu").each(function () {
    if ($(this).attr("data-uniqueid") != uniqueid) return;

    if (!$(this).hasClass(classname)) $(this).addClass(classname);

    if ($(this).hasClass('js_CA_click'))
    {
      var a = $(this).attr("data-toggleinfo");
      if (a != undefined)
      {
        $(a).show();
      }
    }
    commandSelecMeny($(this).attr("data-parentuniqueid"), classname);
  });
}

baseClass.CommandExecuterAdd("jscSelectMenu", function (obj) {
  try {
    let uniqueid = obj.uniqueid;
    let classname = obj.classname;
    classname = classname != undefined ? classname : "active";

    commandUnSelecMeny(uniqueid, classname);
    commandSelecMeny(uniqueid, classname);
  } catch (e) {
    console.log("err: jscSelectMenu", e);
  }
});
